import { getField, updateField } from 'vuex-map-fields';
import families from '@/services/api/families';
import location from '@/services/api/location';
import fieldsRemover from '@/utils/fieldsRemover';
import { isObject } from 'vuetify/lib/util/helpers';
import defaultApi from '@/services/api/defaultApi';
import {
    compareTextWithOneFamily,
    compareText,
    comparePhones,
    compareMultipleFamiliesPhones
} from '@/utils/compareText';
import filters from '@/constants/filters';
import has from 'lodash.has';

const defaultFamilyFormData = () => {
    return {
        first_name: '',
        last_name: '',
        street: '',
        building_number: '',
        flat_number: '',
        city: '',
        province: '',
        postal_code: '',
        phones: []
    };
};

const defaultAboutFamilyData = () => {
    return {
        helpCriteria: [],
        note: ''
    };
};

const defaultSource = () => {
    return {
        category: null,
        name: '',
        phone_number: null
    };
};

const defaultFile = () => {
    return [];
};

const defaultCurrentFamily = () => {
    return {
        name: [],
        surname: [],
        street: [],
        building: [],
        flat: [],
        postalCode: [],
        city: [],
        phones: []
    };
};

const maxDifferentAmount = 4;

export default {
    namespaced: true,
    state: {
        familyFormData: defaultFamilyFormData(),
        consents: {},
        no_street: false,
        aboutFamilyData: defaultAboutFamilyData(),
        source: defaultSource(),
        location: null,
        locationLoader: false,
        noLocationByUser: false,
        isConsentPageVisible: false,
        file: defaultFile(),
        sendLoader: false,
        locationLeaders: [],
        locationNameByWioStruct: null,
        qualifiedFamilies: {
            data: [],
            amount: null,
            isLoading: false,
            pagination: {
                page: 1,
                amount: 20
            }
        },
        noVolunteersFamilies: {
            data: [],
            amount: null,
            isLoading: false,
            pagination: {
                page: 1,
                amount: 20
            }
        },
        similarFamilies: [],
        similarityParameters: null,
        familiesToDecide: [],
        currentFamily: defaultCurrentFamily(),
        formattedSimilarFamilies: [],
        clearMultiplePhone: false,
        UTMParams: null
    },
    getters: {
        getField,
        getLocation: (state) => state.location,
        getLocationLoader: (state) => state.locationLoader,
        getNoLocationByUser: (state) => state.noLocationByUser,
        isConsentPageVisible: (state) => state.isConsentPageVisible,
        getFamilyFormData: (state) => state.familyFormData,
        getConsentFiles: (state) => state.file,
        getAboutFamilyData: (state) => state.aboutFamilyData,
        getFamilySource: (state) => state.source,
        getConsents: (state) => state.consents,
        getSendLoader: (state) => state.sendLoader,
        getQualifiedFamilies: (state) => state.qualifiedFamilies,
        getNoVolunteersFamilies: (state) => state.noVolunteersFamilies,
        getLocationLeaders: (state) => state.locationLeaders,
        getLocationNameByWioStruct: (state) => state.locationNameByWioStruct,
        getSimilarFamilies: (state) => state.similarFamilies,
        getSimilarityParameters: (state) => state.similarityParameters,
        getFamiliesToDecide: (state) => state.familiesToDecide,
        getCurrentFamily: (state) => state.currentFamily,
        getFormattedSimilarFamilies: (state) => state.formattedSimilarFamilies,
        getClearMultiplePhone: (state) => state.clearMultiplePhone,
        getUTMParams: (state) => state.UTMParams
    },
    mutations: {
        updateField,
        setLocation (state, data) {
            state.location = data;
        },
        setLocationLoader (state, data) {
            state.locationLoader = data;
        },
        setNoLocationByUser (state, data) {
            state.noLocationByUser = data;
        },
        setConsentPageVisible (state, data) {
            state.isConsentPageVisible = data;
        },
        setSendLoader (state, data) {
            state.sendLoader = data;
        },
        setQualifiedFamilies (state, data) {
            if (has(data, 'amount')) {
                state.qualifiedFamilies.amount = data.amount;
                state.qualifiedFamilies.data = data.data;
            } else {
                state.qualifiedFamilies.data = data.data;
            }
        },
        setQualifiedFamiliesLoading (state, data) {
            state.qualifiedFamilies.isLoading = data;
        },
        setQualifiedFamiliesPagination (state, data) {
            if (
                Object.prototype.hasOwnProperty.call(data, 'page') &&
        Object.prototype.hasOwnProperty.call(data, 'amount')
            ) {
                state.qualifiedFamilies.pagination = data;
            }
            if (Object.prototype.hasOwnProperty.call(data, 'page')) {
                state.qualifiedFamilies.pagination.page = data.page;
            }
            if (Object.prototype.hasOwnProperty.call(data, 'amount')) {
                state.qualifiedFamilies.pagination.amount = data.amount;
            }
        },
        setNoVolunteersFamilies (state, data) {
            if (has(data, 'amount')) {
                state.noVolunteersFamilies.amount = data.amount;
                state.noVolunteersFamilies.data = data.data;
            } else {
                state.noVolunteersFamilies.data = data.data;
            }
        },
        setNoVolunteersFamiliesLoading (state, data) {
            state.noVolunteersFamilies.isLoading = data;
        },
        setNoVolunteersPagination (state, data) {
            if (
                Object.prototype.hasOwnProperty.call(data, 'page') &&
        Object.prototype.hasOwnProperty.call(data, 'amount')
            ) {
                state.noVolunteersFamilies.pagination = data;
            }
            if (Object.prototype.hasOwnProperty.call(data, 'page')) {
                state.noVolunteersFamilies.pagination.page = data.page;
            }
            if (Object.prototype.hasOwnProperty.call(data, 'amount')) {
                state.noVolunteersFamilies.pagination.amount = data.amount;
            }
        },
        setLocationLeaders (state, data) {
            state.locationLeaders = data;
        },
        setLocationNameByWioStruct (state, data) {
            state.locationNameByWioStruct = data;
        },
        clearFormData (state) {
            state.familyFormData = defaultFamilyFormData();
            state.consents = {};
            state.aboutFamilyData = defaultAboutFamilyData();
            state.source = defaultSource();
            state.location = null;
            state.locationLoader = false;
            state.noLocationByUser = false;
            state.isConsentPageVisible = false;
            state.file = defaultFile();
            state.sendLoader = false;
            state.locationLeaders = [];
            state.locationNameByWioStruct = null;
            state.clearMultiplePhone = true;
            state.UTMParams = null;
            state.no_street = false;
        },
        setSimilarFamilies (state, payload) {
            state.similarFamilies = payload;
        },
        setSimilarityParameters (state, payload) {
            state.similarityParameters = payload;
        },
        assignFamilyData (state, payload) {
            const neededKeys = [
                'first_name',
                'last_name',
                'street',
                'building_number',
                'flat_number',
                'city',
                'province',
                'postal_code',
                'phones_data',
                'initial_consent_files'
            ];
            for (const key in payload) {
                if (neededKeys.includes(key)) {
                    switch (key) {
                    case 'initial_consent_files':
                        state.file = [...payload[key]];
                        break;
                    case 'province':
                        state.familyFormData.province = payload.province.province_id;
                        break;
                    case 'phones_data':
                        state.familyFormData.phones = payload.phones_data.map((el) => {
                            return { number: el };
                        });
                        break;
                    default:
                        state.familyFormData[key] = payload[key];
                    }
                }
            }
        },
        setFamiliesToDecide (state, payload) {
            state.familiesToDecide = payload;
        },
        resetCurrentFamily (state) {
            state.currentFamily = defaultCurrentFamily();
        },
        setCurrentFamily (state, payload) {
            state.currentFamily = payload;
        },
        setFormattedSimilarFamilies (state, payload) {
            state.formattedSimilarFamilies = payload;
        },
        setUTMParams (state, payload) {
            state.UTMParams = payload;
        }
    },
    actions: {
        async getLocation (context, data, internal = true) {
            context.commit('setLocation', null);
            context.commit('setLocationLeaders', null);
            context.commit('setLocationLoader', true);

            let locationRequest = null;
            try {
                locationRequest = await location.getLocation(data).then(({ data }) => {
                    context.commit('setLocation', data.data);
                    return data;
                });
            } catch (e) {
                context.commit('setLocationLoader', false);
                return e;
            }

            if (locationRequest.data.native === false && internal) {
                const wioId =
          locationRequest.data && locationRequest.data.node && locationRequest.data.node.id;
                await context.dispatch('getLocationLeaders', wioId);
            }

            context.commit('setLocationLoader', false);
            return locationRequest;
        },
        getLocationLeaders (context, data) {
            return defaultApi.getWioStructInfo(data).then(({ data }) => {
                context.commit('setLocationLeaders', data.data.leaders);
                context.commit('setLocationNameByWioStruct', data.data.location_name);
                return data;
            });
        },
        postFamilyInternal (context) {
            const supportCriteria = Array.from(
                context.getters.getAboutFamilyData.helpCriteria,
                (x) => x.support_criterion_id
            );

            const files = Array.from(context.getters.getConsentFiles, (x) => x.file);

            const location = context.getters.getLocation;
            const locationId = location && location.node && location.node.id;
            const isNative = location && location.native;
            const chosenOption =
        context.getters.getSimilarityParameters &&
        context.getters.getSimilarityParameters.chosenOption;
            const isConverted = (chosenOption === null || chosenOption === 3) && isNative;
            const formData = new FormData();
            const data = {
                ...context.getters.getFamilyFormData,
                support_criteria: supportCriteria,
                description: context.getters.getAboutFamilyData.note,
                source: { ...context.getters.getFamilySource },
                wio_struct_location_id: locationId,
                initial_consent_files: files,
                consents: context.getters.getConsents
            };
            fieldsRemover(data);

            for (const key in data) {
                if (key === 'initial_consent_files') {
                    data[key].forEach((el, i) => {
                        formData.append(`initial_consent_files_${i}`, el);
                    });
                } else if (isObject(data[key])) {
                    formData.append(key, JSON.stringify(data[key]));
                } else {
                    formData.append(key, data[key]);
                }
            }
            context.commit('setSendLoader', true);
            if (isConverted) {
                if (formData.has('province')) formData.delete('province');
                return families.postFamilyDataWithConvert(formData).finally(() => {
                    context.commit('setSendLoader', false);
                });
            } else {
                if (chosenOption === 1) {
                    formData.delete('province');
                } else if (formData.has('wio_struct_location_id')) formData.delete('wio_struct_location_id');
                return families.postFamilyData(formData).finally(() => {
                    context.commit('setSendLoader', false);
                });
            }
        },
        postFamilyExternal (context) {
            const formData = new FormData();

            const supportCriteria = Array.from(
                context.getters.getAboutFamilyData.helpCriteria,
                (x) => x.support_criterion_id
            );
            const reporterData = context.rootGetters['reporterData/getReporterFormData'];

            const files = Array.from(context.getters.getConsentFiles, (x) => x.file);

            const data = {
                ...context.getters.getFamilyFormData,
                reporters_data: { ...reporterData },
                support_criteria: supportCriteria,
                description: context.getters.getAboutFamilyData.note,
                initial_consent_files: files
            };
            fieldsRemover(data);

            for (const key in data) {
                if (key === 'initial_consent_files') {
                    data[key].forEach((el, i) => {
                        formData.append(`initial_consent_files_${i}`, el);
                    });
                } else if (isObject(data[key])) {
                    formData.append(key, JSON.stringify(data[key]));
                } else {
                    formData.append(key, data[key]);
                }
            }

            context.commit('setSendLoader', true);
            return families.postFamilyToAccept(formData).finally(() => {
                context.commit('setSendLoader', false);
            });
        },
        getMyFamilies (context, payload) {
            const params = new URLSearchParams();
            const pagination = context.getters.getQualifiedFamilies.pagination;
            params.append('limit', pagination.amount);
            const offset = (pagination.page - 1) * pagination.amount;
            params.append('offset', offset);
            const query = payload && payload.searchInput;
            if (query) {
                params.append('query', query);
                delete payload.searchInput;
            }

            context.commit('setQualifiedFamilies', { data: [] });
            context.commit('setQualifiedFamiliesLoading', true);
            return families
                .getMyFamilies({
                    urlParams: params,
                    payload
                })
                .then((data) => {
                    context.commit('setQualifiedFamilies', data.data);
                })
                .finally(() => {
                    context.commit('setQualifiedFamiliesLoading', false);
                });
        },
        getNoVolunteersFamilies (context, payload) {
            const params = new URLSearchParams();
            const pagination = context.getters.getNoVolunteersFamilies.pagination;
            params.append('limit', pagination.amount);
            const offset = (pagination.page - 1) * pagination.amount;
            params.append('offset', offset);
            const query = payload && payload.searchInput;
            if (query) {
                params.append('query', query);
                delete payload.searchInput;
            }

            context.commit('setNoVolunteersFamilies', { data: [] });
            context.commit('setNoVolunteersFamiliesLoading', true);
            return families
                .getFamilies({
                    urlParams: params,
                    payload
                })
                .then((data) => {
                    context.commit('setNoVolunteersFamilies', data.data);
                })
                .finally(() => {
                    context.commit('setNoVolunteersFamiliesLoading', false);
                });
        },
        async checkDuplicateInCurrentEdition (context) {
            const data = {
                first_name: context.getters.getFamilyFormData.first_name,
                last_name: context.getters.getFamilyFormData.last_name,
                street: context.getters.getFamilyFormData.street,
                postal_code: context.getters.getFamilyFormData.postal_code,
                province: context.getters.getFamilyFormData.province,
                city: context.getters.getFamilyFormData.city,
                building_number: context.getters.getFamilyFormData.building_number,
                flat_number: context.getters.getFamilyFormData.flat_number,
                wio_struct_location_id: context.getters.getLocation.node.id
            };
            for (const prop in data) {
                if (!data[prop]) {
                    delete data[prop];
                }
            }

            context.commit('setSendLoader', true);
            context.state.clearMultiplePhone = false;
            let duplicateRequest = null;
            try {
                duplicateRequest = await families.getFamilyDuplicate(data);
            } catch (e) {
                context.commit('setSendLoader', false);
                return e;
            }

            const wioId = duplicateRequest?.data?.wio_struct_location_id;
            if (wioId) {
                await context.dispatch('getLocationLeaders', wioId);
            }

            context.commit('setSendLoader', false);
            return duplicateRequest;
        },
        checkSimilarFamilies (context) {
            const location = context.getters.getLocation;
            const locationId = location && location.node && location.node.id;

            const street = context.getters.getFamilyFormData.street
                ? context.getters.getFamilyFormData.street
                : '';
            const firstName = context.getters.getFamilyFormData.first_name
                ? context.getters.getFamilyFormData.first_name
                : '';
            const flatNumber = context.getters.getFamilyFormData.flat_number
                ? context.getters.getFamilyFormData.flat_number
                : '';

            const params = new URLSearchParams();
            params.append('first_name', firstName);
            params.append('last_name', context.getters.getFamilyFormData.last_name);
            params.append('street', street);
            params.append('postal_code', context.getters.getFamilyFormData.postal_code);
            params.append('city', context.getters.getFamilyFormData.city);
            params.append('building_number', context.getters.getFamilyFormData.building_number);
            params.append('flat_number', flatNumber);
            params.append('wio_struct_location_id', locationId);
            if (context.getters.getFamilyFormData.phones.length > 0) {
                context.getters.getFamilyFormData.phones.forEach((el) => {
                    params.append('phones[]', el.number);
                });
            } else {
                params.append('phones[]', '');
            }
            context.commit('setSendLoader', true);
            return families
                .getSimilarFamilies(params)
                .then((response) => {
                    context.commit('setSimilarFamilies', response.data.data);
                    context.dispatch('formatSimilarFamilies', response.data.data);
                })
                .finally(() => {
                    context.commit('setSendLoader', false);
                });
        },
        overwriteFamilyData (context) {
            let isForm = false;
            const files = Array.from(context.getters.getConsentFiles, (x) => {
                if (Object.prototype.hasOwnProperty.call(x, 'uri')) {
                    return x.uri;
                } else {
                    isForm = true;
                    return x.file;
                }
            });
            const formData = new FormData();
            const _familyData = {
                ...context.getters.getFamilyFormData,
                consents: context.getters.getConsents,
                wio_struct_location_id: context.getters.getLocation.node.id,
                initial_consent_files: files
            };

            fieldsRemover(_familyData);

            for (const key in _familyData) {
                if (key === 'initial_consent_files') {
                    if (isForm) {
                        _familyData[key].forEach((el, i) => {
                            formData.append(`initial_consent_files_${i}`, el);
                        });
                    } else {
                        formData.append('initial_consent_files', JSON.stringify(_familyData[key]));
                    }
                } else if (isObject(_familyData[key])) {
                    formData.append(key, JSON.stringify(_familyData[key]));
                } else {
                    formData.append(key, _familyData[key]);
                }
            }
            if (formData.has('province')) formData.delete('province');
            const data = {
                id: context.getters.getSimilarityParameters.overwriteFamily,
                data: formData
            };

            return families.overwriteFamilyData(data);
        },
        editFamilyData (context, payload) {
            const data = {
                id: payload.familyEditionId,
                data: {
                    ...context.getters.getFamilyFormData
                }
            };
            if (payload.privileged) {
                data.privileged = payload.privileged;
            }
            data.data.phones.forEach((el) => {
                if (Object.prototype.hasOwnProperty.call(el, 'created_at')) {
                    delete el.created_at;
                }
                if (Object.prototype.hasOwnProperty.call(el, 'modified_at')) {
                    delete el.modified_at;
                }
                if (Object.prototype.hasOwnProperty.call(el, 'family_edition_phone_id')) {
                    delete el.family_edition_phone_id;
                }
            });
            if (data.data?.province || data.data?.province === '') delete data.data.province;
            return families.editFamilyData(data);
        },
        async convertToFamily (context, data) {
            context.commit('setSendLoader', true);

            let convertRequest = null;
            try {
                convertRequest = await context.dispatch('familiesToAccept/convertFamilyToAccept', data, {
                    root: true
                });
            } catch (e) {
                context.commit('setSendLoader', false);
                return e;
            }

            context.commit('setSendLoader', true);

            // TODO: return & check `connectFamily` response status code for optional similar families
            // 200 - found duplicate
            // 404 - duplicates not found
            return convertRequest;
        },
        connectFamily (context, data) {
            return families.connectFamily(data);
        },
        connectFamilyDuplicate (context, data) {
            return families.connectFamilyDuplicate(data);
        },
        checkPreviousEditions (context, data) {
            return families.checkPreviousEditions(data);
        },
        checkDuplicateInPreviousEdition (context) {
            const data = {
                first_name: context.rootGetters['family/getFamily'].first_name,
                last_name: context.rootGetters['family/getFamily'].last_name,
                street: context.rootGetters['family/getFamily'].street,
                postal_code: context.rootGetters['family/getFamily'].postal_code,
                province: context.rootGetters['family/getFamily'].province.province_id,
                city: context.rootGetters['family/getFamily'].city,
                building_number: context.rootGetters['family/getFamily'].building_number,
                flat_number: context.rootGetters['family/getFamily'].flat_number,
                wio_struct_location_id: context.rootGetters['family/getFamily'].wio_struct_location_id,
                previousEditions: true
            };

            for (const prop in data) {
                if (!data[prop]) {
                    delete data[prop];
                }
            }

            return families.getFamilyDuplicate(data);
        },
        markAsCheckedPreviousEditions (context, data) {
            return families.markAsChecked(data);
        },
        assignLocation (context, data) {
            return location.assignLocation(data);
        },
        getFamiliesToDecide (context) {
            return families.getFamiliesToDecide().then((data) => {
                context.commit('setFamiliesToDecide', data.data);
            });
        },
        changeFamilyDataInList (context, data) {
            const list = context.getters.getNoVolunteersFamilies.data;
            let _arr;
            if (list.length > 0) {
                _arr = list.map((el) => {
                    if (el.family_edition_id === data.family_edition_id) {
                        el = data;
                        return el;
                    } else {
                        return el;
                    }
                });
                const _families = {
                    amount: context.getters.getNoVolunteersFamilies.amount,
                    data: _arr
                };
                context.commit('setNoVolunteersFamilies', _families);
            }
        },
        removeFamilyRecord (context, id) {
            const list = context.getters.getNoVolunteersFamilies.data;
            const _arr = [...list];
            if (list.length > 0) {
                const index = _arr.findIndex((el) => el.family_edition_id === id);
                if (index !== -1) {
                    _arr.splice(index, 1);
                }
                const _families = {
                    amount: context.getters.getNoVolunteersFamilies.amount - 1,
                    data: _arr
                };
                context.commit('setNoVolunteersFamilies', _families);
            }
        },
        setFormattedDataForOneFamily (context, _data) {
            compareTextWithOneFamily(
                context.getters.getFamilyFormData.first_name == null
                    ? ''
                    : context.getters.getFamilyFormData.first_name,
                _data.val[0].family_edition.first_name == null
                    ? ''
                    : _data.val[0].family_edition.first_name,
                _data._currentFamily.name,
                _data._formattedSimilarFamilies[0].name
            );

            compareTextWithOneFamily(
                context.getters.getFamilyFormData.last_name,
                _data.val[0].family_edition.last_name,
                _data._currentFamily.surname,
                _data._formattedSimilarFamilies[0].surname
            );

            compareTextWithOneFamily(
                context.getters.getFamilyFormData.street == null
                    ? ''
                    : filters.afterSpace(context.getters.getFamilyFormData.street),
                _data.val[0].family_edition.street == null
                    ? ''
                    : filters.afterSpace(_data.val[0].family_edition.street),
                _data._currentFamily.street,
                _data._formattedSimilarFamilies[0].street
            );

            compareTextWithOneFamily(
                context.getters.getFamilyFormData.building_number,
                _data.val[0].family_edition.building_number,
                _data._currentFamily.building,
                _data._formattedSimilarFamilies[0].building
            );

            compareTextWithOneFamily(
                !context.getters.getFamilyFormData.flat_number ||
          context.getters.getFamilyFormData.flat_number === null
                    ? ''
                    : filters.beforeSlash(context.getters.getFamilyFormData.flat_number),
                _data.val[0].family_edition.flat_number == null
                    ? ''
                    : filters.beforeSlash(_data.val[0].family_edition.flat_number),
                _data._currentFamily.flat,
                _data._formattedSimilarFamilies[0].flat
            );

            compareTextWithOneFamily(
                filters.postalCode(context.getters.getFamilyFormData.postal_code),
                filters.postalCode(_data.val[0].family_edition.postal_code),
                _data._currentFamily.postalCode,
                _data._formattedSimilarFamilies[0].postalCode
            );

            compareTextWithOneFamily(
                filters.beforeComma(context.getters.getFamilyFormData.city),
                filters.beforeComma(_data.val[0].family_edition.city),
                _data._currentFamily.city,
                _data._formattedSimilarFamilies[0].city
            );

            comparePhones(
                maxDifferentAmount,
                context.getters.getFamilyFormData.phones,
                _data.val[0].family_edition.phones,
                _data._currentFamily.phones,
                _data._formattedSimilarFamilies[0].phones
            );
        },
        setFormattedDataForMultipleFamilies (context, _data) {
            compareText(
                context.getters.getFamilyFormData.first_name == null
                    ? ''
                    : context.getters.getFamilyFormData.first_name,
                _data.el.family_edition.first_name == null ? '' : _data.el.family_edition.first_name,
                _data._currentFamily.name,
                _data._formattedSimilarFamilies[_data.i].name
            );

            compareText(
                context.getters.getFamilyFormData.last_name,
                _data.el.family_edition.last_name,
                _data._currentFamily.surname,
                _data._formattedSimilarFamilies[_data.i].surname
            );

            compareText(
                context.getters.getFamilyFormData.street == null
                    ? ''
                    : filters.afterSpace(context.getters.getFamilyFormData.street),
                _data.el.family_edition.street == null
                    ? ''
                    : filters.afterSpace(_data.el.family_edition.street),
                _data._currentFamily.street,
                _data._formattedSimilarFamilies[_data.i].street
            );

            compareText(
                context.getters.getFamilyFormData.building_number,
                _data.el.family_edition.building_number,
                _data._currentFamily.building,
                _data._formattedSimilarFamilies[_data.i].building
            );

            compareText(
                !context.getters.getFamilyFormData.flat_number ||
          context.getters.getFamilyFormData.flat_number === null
                    ? ''
                    : filters.beforeSlash(context.getters.getFamilyFormData.flat_number),
                _data.el.family_edition.flat_number === null
                    ? ''
                    : filters.beforeSlash(_data.el.family_edition.flat_number),
                _data._currentFamily.flat,
                _data._formattedSimilarFamilies[_data.i].flat
            );

            compareText(
                filters.postalCode(context.getters.getFamilyFormData.postal_code),
                filters.postalCode(_data.el.family_edition.postal_code),
                _data._currentFamily.postalCode,
                _data._formattedSimilarFamilies[_data.i].postalCode
            );

            compareText(
                filters.beforeComma(context.getters.getFamilyFormData.city),
                filters.beforeComma(_data.el.family_edition.city),
                _data._currentFamily.city,
                _data._formattedSimilarFamilies[_data.i].city
            );

            compareMultipleFamiliesPhones(
                maxDifferentAmount,
                context.getters.getFamilyFormData.phones,
                _data.el.family_edition.phones,
                _data._currentFamily.phones,
                _data._formattedSimilarFamilies[_data.i].phones
            );
        },
        formatSimilarFamilies (context, val) {
            if (val.length > 0) {
                const _data = {
                    val,
                    _currentFamily: defaultCurrentFamily(),
                    _formattedSimilarFamilies: []
                };
                if (val.length === 1) {
                    const _family = {
                        name: [],
                        surname: [],
                        street: [],
                        building: [],
                        flat: [],
                        postalCode: [],
                        city: [],
                        phones: [],
                        creator: null,
                        family_edition_id: null,
                        status: null
                    };
                    const firstFamily = val[0].family_edition;
                    _family.creator = firstFamily.creator;
                    _family.family_edition_id = firstFamily.family_edition_id;
                    _family.status = firstFamily.status;
                    _family.edition = firstFamily.edition && firstFamily.edition.name;
                    _family.primary_volunteer_assigned = firstFamily.primary_volunteer_assigned;
                    _data._formattedSimilarFamilies.push(_family);
                    context.dispatch('setFormattedDataForOneFamily', _data);
                } else if (val.length > 1) {
                    val.forEach((el, index) => {
                        const _family = {
                            name: [],
                            surname: [],
                            street: [],
                            building: [],
                            flat: [],
                            postalCode: [],
                            city: [],
                            phones: [],
                            creator: null,
                            family_edition_id: null,
                            status: null,
                            primary_volunteer_assigned: null
                        };
                        _family.creator = el.family_edition.creator;
                        _family.family_edition_id = el.family_edition.family_edition_id;
                        _family.status = el.family_edition.status;
                        _family.edition = el.family_edition.edition && el.family_edition.edition.name;
                        _family.primary_volunteer_assigned = el.family_edition.primary_volunteer_assigned;
                        _data._formattedSimilarFamilies.push(_family);
                        _data.el = el;
                        _data.i = index;
                        context.dispatch('setFormattedDataForMultipleFamilies', _data);
                    });
                }

                context.commit('setCurrentFamily', _data._currentFamily);
                context.commit('setFormattedSimilarFamilies', _data._formattedSimilarFamilies);
            }
        },
        removeFamilyConsent (context, data) {
            return families.removeConsent(data);
        },
        replaceFamilyConsent (context, data) {
            const files = Array.from(data.files, (x) => x.file);
            const formData = new FormData();

            for (const fileKey in files) {
                formData.append(fileKey, files[fileKey]);
            }

            delete data.files;

            return families.replaceConsent(data, formData);
        },
        addFamilyConsent (context, data) {
            const files = Array.from(data.files, (x) => x.file);
            const formData = new FormData();

            for (const fileKey in files) {
                formData.append(fileKey, files[fileKey]);
            }

            return families.addConsent(data, formData);
        }
    }
};
